import { get } from 'lodash'

export const headers = (intl = {}) => [
  intl.formatMessage({
    id: 'table.award_unit'
  }),
  intl.formatMessage({
    id: 'table.already_running'
  }),
  intl.formatMessage({
    id: 'table.licence_holder'
  }),
  intl.formatMessage({
    id: 'table.email'
  }),
  intl.formatMessage({
    id: 'table.phone'
  }),
  intl.formatMessage({
    id: 'table.coordinator'
  })
]

export const line = (data = []) =>
  data.map(item => {
    return {
      line: [
        get(item, 'awardUnitRegistration.organization.name'),
        get(item, 'awardUnitRegistration.alreadyRunningAward'),
        `${get(item, 'awardUnitRegistration.firstName')} ${get(item, 'awardUnitRegistration.lastName')}`,
        get(item, 'awardUnitRegistration.email'),
        get(item, 'awardUnitRegistration.phoneNumber'),
        `${get(item, 'awardUnitRegistration.awardLeaderRegistration.firstName')} ${get(item, 'awardUnitRegistration.awardLeaderRegistration.lastName')}`
      ]
    }
  })
